'use client'
import { useEffect } from 'react';
import { analyticsEvent, analyticsEventData, AppContextValue, useAppContext } from '../context/app-context';


export const useGoogleAnalyticsUseContextEvent = (eventName: analyticsEvent, data: analyticsEventData) => {
  let appContext = useAppContext();
  useEffect(() => {
    googleAnalyticsEvent(eventName, appContext, data);
  }, [])
};


export const googleAnalyticsEvent = (eventName: analyticsEvent, appContext: AppContextValue, data: analyticsEventData) => {

  let affx = window.localStorage.getItem("__affx_ref")
  let affData;
  if (affx) {
    try {
      affData = JSON.parse(affx)?.value
    } catch (e) {
      console.log("affx fail!");
    }
  }

  //@ts-ignore
  window.gtag?.("event", eventName, {
    ...data,
    user_id: appContext.user?.id,
    sales_channels: Array.isArray(appContext.salesChannels) ? appContext.salesChannels?.map(s => s.id).toString() : "",
    sales_channels_name: Array.isArray(appContext.salesChannels) ? appContext.salesChannels?.map(s => s.name).toString() : "",
    affx: affData
  });
};

